"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWeeklyCoachingSubscriptionThatShouldBeFixed = exports.isWeeklyCoachingPlanId = exports.weeklyCoachingPlanIds = void 0;
exports.weeklyCoachingPlanIds = [
    "weekly-coaching",
    "daily-coaching",
];
const isWeeklyCoachingPlanId = (planId) => exports.weeklyCoachingPlanIds.includes(planId);
exports.isWeeklyCoachingPlanId = isWeeklyCoachingPlanId;
const isWeeklyCoachingSubscriptionThatShouldBeFixed = (sub) => exports.isWeeklyCoachingPlanId(sub.planId) && sub.metadata === undefined;
exports.isWeeklyCoachingSubscriptionThatShouldBeFixed = isWeeklyCoachingSubscriptionThatShouldBeFixed;
//# sourceMappingURL=weekly_coaching_utils.js.map